/**
 * @generated SignedSource<<f4fa997ba01b4cf015f810a02fa0b5e9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavLogoHamburger_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useNotificationsConfig_seller">;
  readonly " $fragmentType": "NavLogoHamburger_seller";
};
export type NavLogoHamburger_seller$key = {
  readonly " $data"?: NavLogoHamburger_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavLogoHamburger_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavLogoHamburger_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNotificationsConfig_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "512389705ed7b7c8750df37c571ac4cb";

export default node;
